import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function PhilosophySection() {
  const {
    lang
  } = useLanguage();
  return <section id="filosofia" className="py-32 lg:py-44 bg-inkova-cream" data-id="element-290">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-291">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary mb-10" data-id="element-292">
          {lang === 'es' ? 'NUESTRA FILOSOFÍA' : 'OUR PHILOSOPHY'}
        </motion.span>
        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: 'easeOut',
        delay: 0.1
      }} className="font-serif text-[32px] sm:text-[5vw] lg:text-[56px] leading-[1.15] tracking-[-0.5px] text-inkova-dark" data-id="element-293">
          {lang === 'es' ? <>
              No construimos sitios web.{' '}
              <em className="italic text-inkova-lavender" data-id="element-294">
                Diseñamos negocios digitales
              </em>{' '}
              que reflejan quién eres.
            </> : <>
              We don't build websites.{' '}
              <em className="italic text-inkova-lavender" data-id="element-295">
                We design digital businesses
              </em>{' '}
              that reflect who you are.
            </>}
        </motion.h2>
      </div>
    </section>;
}